import axios from '@/services/axios-auth-wrapper';

export default {
    getByProjectId: (projectId) => {
        return axios.get(url + 'byproject/' + projectId);
    },
    getByUserId: (userId) => {
        return axios.get(url + 'byuser/' + userId);
    },
    shareProject: (data) => {
        return axios.post(url + 'create', data);
    },
    unshareProject: (projectId) => {
        return axios.delete(url + 'byproject/' + projectId);
    }
};

const url = process.env.VUE_APP_CONVERSABILITY_API_URL + '/api/project/share/';
